export default __webpack_public_path__ + "images/purchase-icon.84dc134bc92ddf892c7010f1134721a3.svg";